import { useState, useEffect } from 'react';
import { alertaCargandoProceso, alertaGeneral } from '../../utils/alertas';
import apiClient from '../../utils/axiosPetition';
import InputFile from '../../utils/InputFile';

const ReenvioDocumentos = ({ doctor, setShow }) => {
    const [files, setFiles] = useState({});

    const handleChange = (e) => {
        setFiles({
            ...files,
            [e.target.name]: e.target.files[0]
        });
    }

    console.log(files);

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();

        for (const key in files) {
            formData.append(key, files[key]);
        }

        alertaCargandoProceso({
            titulo: "Reenviando documentos",
            messageHtml: "Reenviando documentos, por favor espera un momento...",
            funcionAsync: () => {
                apiClient.put(`/api/afiliado/reenvio-documentos/${doctor._id}`, formData)
                    .then(res => {
                        alertaGeneral({
                            titulo: "Documentos reenviados",
                            messageHtml: "Los documentos han entrado en revisión nuevamente",
                        });
                        doctor.estado = "en_revision";
                        setShow(false);
                    })
                    .catch(error => {
                        alertaGeneral({
                            titulo: "Error",
                            messageHtml: error.response?.data?.message || "Ocurrió un error al reenviar los documentos, por favor intente de nuevo.",
                            isError: true
                        });
                    });
            }
        })
    }

    return (
        <div className="bg-white p-6">
            <button
                type="button"
                className="mb-8 button-gray"
                onClick={() => setShow(false)}
            >
                Volver
            </button>
            <form className="space-y-6" onSubmit={handleSubmit} encType="multipart-form-data">

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    {/* Aqui se mostraran los inputs de los archivos que no pasaron */}
                    {doctor && doctor.documentsApproved && doctor.documentsApproved.filter(f => f.isApproved === false).map((file, index) => (
                        <div key={index} className="col-span-1">
                            <label className="form-label capitalize"> {file?.document?.replace(/_/g, ' ')} </label>
                            <InputFile 
                                name={file?.document}
                                fileName={files[file?.document]?.name}
                                onChange={handleChange}
                                accept=".pdf, .jpg, .jpeg, .png, .svg"
                            />
                            <p className="text-[#1f94c2ff]">
                                Observacion:{" "}
                                <span className="text-red-500">{file.rejectionReason}</span>
                            </p>
                        </div>
                    ))}

                </div>

                {/* Botón de Enviar */}
                <div className="flex justify-end">
                    <button
                        type="submit"
                        className="button-send"
                    >
                        Reenviar Documentos
                    </button>
                </div>
            </form >
        </div >
    )
}

export default ReenvioDocumentos;